import React from 'react';
import { BsTwitter, BsInstagram } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';
import { FaGithub } from 'react-icons/fa'
import { FaLinkedin } from 'react-icons/fa'
import { SiTableau } from 'react-icons/si'


const SocialMedia = () => (
  <>
  <div className="app__social">
    {/* <div>
      <BsTwitter />
    </div>
    <div>
      <FaFacebookF />
    </div>
    <div>
      <BsInstagram />
    </div> */}
    <div>
      <a href="https://github.com/siemeris" target="_blank"> <FaGithub /></a>
      {/* <FaGithub /> */}
    </div>
    <div>
    <a href="https://www.linkedin.com/in/isabelsierramerino/" target="_blank"> <FaLinkedin /></a>
    </div>
    <div>
      <a href="https://public.tableau.com/app/profile/siemeris" target="_blank"> <SiTableau /></a>
      {/* <FaGithub /> */}
    </div>
  </div>
  </>
);

export default SocialMedia;